import React from "react";
import SidebarComp from "../../components/sidebar/sidebar";
import NavbarComp from "../../components/navbar/navbar";
import Transaction from "../../components/body/billing/Transactions";



const TransactionScreen = () => {
  return (
    <div className="container-scroller">
      <NavbarComp />
      <div className="container-fluid page-body-wrapper">
        <SidebarComp />
        <div className="main-panel">
          <div className="content-wrapper">
            <Transaction />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionScreen;
